module.exports = __webpack_public_path__ + "img/chevron.42581d11.svg";